import { Link } from "react-router-dom";
import { TableHeadersType } from "../../constant/tableHeadersConstants/tableHeadersType";
import { MonthWiseClientTimesheetType } from "../../redux/timeSheet/timeSheetType";
import { CircularAvatar } from "../commons";
import { formatDate } from "../../utils/commonFunctions";


type AppProps = {
  data: MonthWiseClientTimesheetType[]|[];
  tableHeader: TableHeadersType[];
  currentStartDate:string;
  currentEndDate:string;

};
const MonthlyTimesheetReportTableData = ({
  data,
  tableHeader,
  currentEndDate,
  currentStartDate

}: AppProps) => {
  const finalRedirectLink = {
    pathname: `/time-sheet-reports/client-wise-time-sheet-report`,
  };
  const handleSetLocalStorageData = (itemData: any) => {
    localStorage.setItem("client_code", itemData?.client_code);
    localStorage.setItem("client_name", itemData?.name);
    localStorage.setItem("start_date", currentStartDate);
    localStorage.setItem("end_date", currentEndDate);
  };
  return (
    <>
      {data &&
        data?.length > 0 &&
        data?.map((itemData: any) => {
          return (
            <tr key={itemData?._id}>
              {tableHeader?.map((item: TableHeadersType) => {
                if (item?.value === "name") {
                  return <td>
                    <div
                          className="ml-2"
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            gap: "7px",
                          }}
                        >
                          <CircularAvatar
                            name={`${itemData?.name}`}
                            image={
                              itemData?.profile_pic &&
                              itemData?.profile_pic?.file_url
                            }
                          />
                          <div
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            textDecoration: "underline",}}
                          >
                            <Link 
                            target="_blank"
                            to={finalRedirectLink}
                            onClick={() =>
                              handleSetLocalStorageData(
                              itemData
                              )
                            }
                            style={{color:'#262a44', cursor: "pointer",textDecoration:'none'}}
                         
                            >

                         {`${itemData?.name} (${itemData?.client_code})`}
                            </Link>
                          </div>
                          </div>
                    </td>;
                } else if (item?.value == "total_hours_charged") {
                  return <td 
                  >{itemData?.total_hours_charged}</td>;
                }
                else if (item?.value == "target_hours") {
                    return <td>
                      {/* {itemData?.target_hours? itemData?.target_hours:"NA"} */}
                      {itemData?.target_hours !== null && itemData?.target_hours !== undefined ? itemData?.target_hours : "NA"}
                      </td>;
                  }
              })}
            </tr>
          );
        })}
    </>
  );
};

export default MonthlyTimesheetReportTableData;

